import { DatePipe, NgOptimizedImage } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IncompleteOrder } from '@layout/core/interfaces';
import { TranslateModule } from '@ngx-translate/core';
import { LoaderComponent } from '@shared/components';
import { DeleteDraftModalService } from '@shared/components/orders-and-retests/delete-draft-modal/delete-draft-modal.service';
import { OrderStatusEnum } from '@shared/enums';
import { AppRoutes } from '@shared/helpers';
import { ButtonModule } from 'primeng/button';
import { Subscription } from 'rxjs';
import { MenuCartOrdersService } from './menu-cart-orders.service';

@Component({
    selector: 'app-menu-cart-orders',
    templateUrl: './menu-cart-orders.component.html',
    styleUrls: ['./menu-cart-orders.component.scss'],
    standalone: true,
    imports: [TranslateModule, ButtonModule, RouterModule, LoaderComponent, DatePipe, NgOptimizedImage],
})
export class MenuCartOrdersComponent implements OnDestroy {
    private readonly subscriptions = new Subscription();

    readonly appRoutes = AppRoutes;
    readonly orderStatuses = OrderStatusEnum;

    cartOrders!: IncompleteOrder[];
    isLoadingData: boolean = false;

    constructor(
        private deleteDraftModalService: DeleteDraftModalService,
        private menuCartOrdersService: MenuCartOrdersService
    ) {
        this.subscriptions.add(
            this.deleteDraftModalService.deletedSuccessfully$.subscribe(orderId => {
                this.menuCartOrdersService.removeIncompleteOrder(orderId);
            })
        );
        this.subscriptions.add(
            this.menuCartOrdersService.menuCartOrders$.subscribe(menuCartOrders => {
                this.saveCartOrders(menuCartOrders);
            })
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    private async saveCartOrders(cartOrders: IncompleteOrder[] | null): Promise<void> {
        if (cartOrders === null) {
            this.isLoadingData = true;
        } else {
            this.cartOrders = cartOrders;
            this.isLoadingData = false;
        }
    }

    displayDeleteOrderModal(orderId: number) {
        this.deleteDraftModalService.selectedOrderId$.next(orderId);
    }
}
